import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import ButtonImg from "../../assets/monitor.png";
import LoadingImage from "../../assets/chart-graphic.svg";
import InfoImage from "../../assets/Info-13.svg";
import { Container } from "@mui/material";

import "./index.css";
export default function index() {
  return (
    <>
      <Container>
        <Grid container className="main-container-section2">
          <Grid item lg={6} md={6} sm={12} xs={12} className="main-text-div">
            <Typography className="main-text-1">
              Terra Treasury
              <Typography className="main-text-1">
                offers optimized
                <Typography className="main-text-2">interest</Typography>
              </Typography>
            </Typography>
            <Grid>
              <Typography className="section-text">
                Terra Treasury’s yield is stable, secure and attractive.
                <Typography className="section-text"></Typography>t is powered
                by staking returns and 3rd. generation
                <Typography className="section-text">
                  arbitrage farming from multiple proof of stake{" "}
                  <Typography className="section-text"></Typography>blockchains
                  & DEX’s.
                </Typography>
              </Typography>
            </Grid>
            <Grid className="main-buttons-div">
              <Button className="main-button-section">
                <Typography className="main-button-section">
                  Learn More
                </Typography>
                <img src={InfoImage} />
              </Button>
              <Button className="header-button">
                <img src={ButtonImg} />
                <Typography className="header-button-text">WebApp</Typography>
              </Button>
            </Grid>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12} className="main-img-div-2">
            <img src={LoadingImage} className="main-image-2" />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
